
import { useState, useEffect } from 'react';
import { toast } from '../components/ui/use-toast';
import FortuneMessage from '../components/FortuneMessage';
import AdModal from '../components/AdModal';
import FortuneBackground from '../components/FortuneBackground';
import FortuneHeader from '../components/FortuneHeader';
import FortuneContainer from '../components/FortuneContainer';
import Navigation from "../components/Navigation";
import MainPageHelmet from '../components/fortune/MainPageHelmet';
import FortuneMainContent from '../components/fortune/FortuneMainContent';
import { useFortuneAvailability } from '../hooks/useFortuneAvailability';
import { getRandomFortune } from '../utils/fortuneData';
import { recordFortune } from '../utils/cookieStorage';

const Index = () => {
  console.log('Index component starting to render');
  
  // Basic state to check if component works
  const [componentMounted, setComponentMounted] = useState<boolean>(false);
  
  // Normal fortune state
  const [fortune, setFortune] = useState<string>('');
  const [showFortune, setShowFortune] = useState<boolean>(false);
  const [showAdModal, setShowAdModal] = useState<boolean>(false);
  
  // Custom hook for fortune availability
  const { 
    canUseFortune, 
    nextFortuneTime, 
    checkFortuneAvailability 
  } = useFortuneAvailability();
  
  // Fixed improper use of useState for an effect
  useEffect(() => {
    setComponentMounted(true);
  }, []);
  
  // Simplified render to debug
  if (!componentMounted) {
    return <div className="p-8">Loading... Please wait.</div>;
  }
  
  const handleOpenCookie = () => {
    console.log('Cookie clicked');
    if (!canUseFortune) {
      setShowAdModal(true);
      return;
    }
    
    const newFortune = getRandomFortune();
    console.log('Generated fortune:', newFortune);
    setFortune(newFortune);
    setShowFortune(true);
    recordFortune();
    
    try {
      checkFortuneAvailability();
    } catch (error) {
      console.error('Error checking fortune availability:', error);
    }
  };
  
  const handleCloseFortune = () => {
    setShowFortune(false);
  };
  
  const handleAdComplete = () => {
    try {
      checkFortuneAvailability();
      
      toast({
        title: "Fortune Available",
        description: "You can now get another fortune cookie.",
      });
    } catch (error) {
      console.error('Error in ad complete handler:', error);
    }
  };
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 pb-40 relative overflow-hidden">
      <MainPageHelmet />
      
      {/* Background decoration */}
      <FortuneBackground />
      
      <div className="w-full max-w-4xl mx-auto mb-6 absolute top-4 left-0 right-0">
        <Navigation />
      </div>
      
      <FortuneContainer>
        <FortuneHeader />

        <FortuneMainContent 
          canUseFortune={canUseFortune}
          nextFortuneTime={nextFortuneTime}
          onOpenCookie={handleOpenCookie}
          onRefresh={() => setShowAdModal(true)}
        />
      </FortuneContainer>
      
      {showFortune && (
        <FortuneMessage fortune={fortune} onClose={handleCloseFortune} />
      )}
      
      {showAdModal && (
        <AdModal 
          onClose={() => setShowAdModal(false)} 
          onAdComplete={handleAdComplete} 
        />
      )}
    </div>
  );
};

export default Index;
